module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "current_tickets"
  }, [_c('h3', {
    staticClass: "component_heading"
  }, [_vm._v(_vm._s(_vm.$t("tickets_and_bar.tickets.heading")))]), _vm._v(" "), (_vm.orders.length > 0) ? _c('div', {
    staticClass: "tickets"
  }, _vm._l((_vm.orders), function(order, orderNum) {
    return _c('div', {
      key: orderNum,
      staticClass: "ticket"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "poster-holder",
      style: ({
        'background-image': _vm.winW > 1024 ? 'none' : _vm.films[order.film].mob_poster ? 'url(https://multiplex.ua/' + _vm.films[order.film].mob_poster + ')' : 'url(/static/img/mob_poster_placeholder.jpg)'
      })
    }, [_c('img', {
      staticClass: "poster",
      attrs: {
        "src": 'https://multiplex.ua/' + _vm.films[order.film].inner_poster
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "poster-holder-mask"
    }), _vm._v(" "), (_vm.winW < 1024) ? _c('div', {
      staticClass: "poster-top"
    }, [_c('h4', [_c('a', {
      attrs: {
        "href": 'https://multiplex.ua/movie/' + _vm.films[order.film].id
      }
    }, [_vm._v(_vm._s(_vm.films[order.film][_vm.$i18n.locale].title))])]), _vm._v(" "), _c('span', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.setTktQr(order, _vm.films[order.film][_vm.$i18n.locale].title)
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M2 0C.9 0 0 .9 0 2v6h4v2h2V8h2V0H2zm6 8v2H6v2H4v-2H2v2H0v6c0 1.1.9 2 2 2h8v-2H8v-2h2v2h2v-2h2v-2h4v-2h2v-2h-4v2h-2v-2h-2V8H8zm4 0h2v2h2V8h4V2c0-1.1-.9-2-2-2h-6v8zm6 6v2h2v-2h-2zm0 2h-2v2h2v-2zm0 2v2c1.1 0 2-.9 2-2h-2zm-2 0h-2v2h2v-2zM2 2h4v4H2V2zm12 0h4v4h-4V2zM3 3v2h2V3H3zm12 0v2h2V3h-2zm-7 9h2v2H8v-2zm-6 2h4v4H2v-4zm1 1v2h2v-2H3z",
        "fill": "#FFF",
        "fill-rule": "nonzero"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("profile.show_cards")) + " Qr код")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "ticket-top"
    }, [(_vm.winW > 1024) ? _c('h4', {
      staticClass: "ticket-heading"
    }, [_c('a', {
      attrs: {
        "href": 'https://multiplex.ua/movie/' + _vm.films[order.film].id
      }
    }, [_vm._v(_vm._s(_vm.films[order.film][_vm.$i18n.locale].title))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ticket-buttons"
    }, [_c('a', {
      staticClass: "button dl",
      attrs: {
        "href": 'https://order.multiplex.ua' + order.pdf_url,
        "target": "_blank"
      }
    }, [_c('svg', {
      attrs: {
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h20v20H0z"
      }
    }), _c('path', {
      attrs: {
        "d": "M9 0v2h2V0H9zm0 4v8.586L5.707 9.293l-1.414 1.414L10 16.414l5.707-5.707-1.414-1.414L11 12.586V4H9zM0 15v3c0 1.093.907 2 2 2h16c1.093 0 2-.907 2-2v-3h-2v3H2v-3H0z",
        "fill": "#FFF",
        "fill-rule": "nonzero"
      }
    })])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("main_page.tickets.print")))])]), _vm._v(" "), _c('div', {
      staticClass: "divider"
    }), _vm._v(" "), (_vm.winW > 1024) ? _c('span', {
      staticClass: "button qr",
      on: {
        "click": function($event) {
          return _vm.setTktQr(order, _vm.films[order.film][_vm.$i18n.locale].title)
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M2 0C.9 0 0 .9 0 2v6h4v2h2V8h2V0H2zm6 8v2H6v2H4v-2H2v2H0v6c0 1.1.9 2 2 2h8v-2H8v-2h2v2h2v-2h2v-2h4v-2h2v-2h-4v2h-2v-2h-2V8H8zm4 0h2v2h2V8h4V2c0-1.1-.9-2-2-2h-6v8zm6 6v2h2v-2h-2zm0 2h-2v2h2v-2zm0 2v2c1.1 0 2-.9 2-2h-2zm-2 0h-2v2h2v-2zM2 2h4v4H2V2zm12 0h4v4h-4V2zM3 3v2h2V3H3zm12 0v2h2V3h-2zm-7 9h2v2H8v-2zm-6 2h4v4H2v-4zm1 1v2h2v-2H3z",
        "fill": "#FFF",
        "fill-rule": "nonzero"
      }
    })]), _vm._v(" "), _c('span', [_vm._v("Qr-код")])]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "button return",
      attrs: {
        "href": 'https://multiplex.ua/faq#refund?cid=' + order.cinema_vista_id + '&bn=' + order.booking_number,
        "target": "_blank"
      }
    }, [_c('svg', {
      attrs: {
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h20v20H0z"
      }
    }), _c('path', {
      attrs: {
        "d": "M5.129 1.967a.747.747 0 0 0-.404.195L.293 6.272a.999.999 0 0 0 0 1.414l4.432 4.11A.76.76 0 0 0 6 11.239V8h7.5c2.48 0 4.5 2.02 4.5 4.5S15.98 17 13.5 17H13a1 1 0 1 0 0 2h.5c3.57 0 6.5-2.93 6.5-6.5S17.07 6 13.5 6H6V2.72a.761.761 0 0 0-.871-.753zM5 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
        "fill": "#FFF",
        "fill-rule": "nonzero"
      }
    })])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("main_page.tickets.return")))])])])]), _vm._v(" "), _c('div', {
      staticClass: "ticket-body"
    }, [_c('div', {
      staticClass: "kvs"
    }, [_c('div', {
      staticClass: "kv"
    }, [_c('p', {
      staticClass: "key"
    }, [_vm._v(_vm._s(_vm.$t("main_page.tickets.num_tickets")))]), _vm._v(" "), _c('p', {
      staticClass: "val"
    }, [_vm._v(_vm._s(order.tickets.length))])]), _vm._v(" "), _c('div', {
      staticClass: "kv"
    }, [_c('p', {
      staticClass: "key"
    }, [_vm._v(_vm._s(_vm.$t("main_page.tickets.date_start")))]), _vm._v(" "), _c('p', {
      staticClass: "val"
    }, [_vm._v(_vm._s(order.dateStr) + ", " + _vm._s(order.timeStr))])]), _vm._v(" "), _c('div', {
      staticClass: "kv"
    }, [_c('p', {
      staticClass: "key"
    }, [_vm._v(_vm._s(_vm.$t("main_page.tickets.cinema")) + " / зал")]), _vm._v(" "), _c('p', {
      staticClass: "val"
    }, [_c('a', {
      attrs: {
        "href": 'https://multiplex.ua/cinema/' + _vm.dicts.cinemasById[order.cinema].url
      }
    }, [_vm._v(_vm._s(_vm.dicts.cinemasById[order.cinema].name) + " / " + _vm._s(order.screen_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "kv"
    }, [_c('p', {
      staticClass: "key"
    }, [_vm._v(_vm._s(_vm.$t("main_page.tickets.address")))]), _vm._v(" "), _c('p', {
      staticClass: "val"
    }, [_vm._v(_vm._s(_vm.dicts.citiesById[_vm.dicts.cinemasById[order.cinema].city_id].name) + ", " + _vm._s(_vm.dicts.cinemasById[order.cinema].address))])]), _vm._v(" "), _c('div', {
      staticClass: "kv"
    }, [_c('p', {
      staticClass: "key"
    }, [_vm._v(_vm._s(_vm.$t("main_page.tickets.order_num")))]), _vm._v(" "), _c('p', {
      staticClass: "val"
    }, [_vm._v(_vm._s(order.booking_number))])]), _vm._v(" "), (order.bar.length > 0) ? _c('div', {
      staticClass: "kv"
    }, [_c('p', {
      staticClass: "key"
    }, [_vm._v(_vm._s(_vm.$t("main_page.tickets.bar_goods")))]), _vm._v(" "), _c('div', {
      staticClass: "val"
    }, [_c('div', {
      staticClass: "bar_items"
    }, _vm._l((order.bar), function(barpos, barposnum) {
      return _c('div', {
        key: barposnum,
        staticClass: "bar_pos"
      }, [_c('p', {
        staticClass: "qty"
      }, [_vm._v(_vm._s(barpos.qty) + "шт")]), _vm._v(" "), _c('p', {
        staticClass: "name"
      }, [_vm._v(_vm._s(_vm.items[barpos.item].name))])])
    }), 0)])]) : _vm._e()])])])])
  }), 0) : _c('p', {
    staticClass: "notickets"
  }, [_vm._v(_vm._s(_vm.$t("main_page.tickets.no_tickets")) + ". "), _c('a', {
    attrs: {
      "href": "https://multiplex.ua"
    }
  }, [_vm._v(_vm._s(_vm.$t("main_page.tickets.time_to_buy")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05059fd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tickets-and-bar/tickets.vue
// module id = 287
// module chunks = 1